import { render, staticRenderFns } from "./ReservationSection.vue?vue&type=template&id=c58abc36&scoped=true"
import script from "./ReservationSection.vue?vue&type=script&lang=js"
export * from "./ReservationSection.vue?vue&type=script&lang=js"
import style0 from "./ReservationSection.vue?vue&type=style&index=0&id=c58abc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58abc36",
  null
  
)

export default component.exports